import {
  AccountsService,
  GrowthNudgeKey,
  GrowthNudgeState,
} from 'base/accounts_service';
import { Button } from 'base/ui/button';
import { IconChat, IconClear } from 'base/ui/icons';
import { Inline, Rows } from 'base/ui/layout';
import { TextMedium, TextSmallLight } from 'base/ui/typography';
import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './growth_nudges.css';

export function MaybeGrowthNudge({
  growthNudgeKey,
  accountsService,
}: {
  growthNudgeKey: GrowthNudgeKey;
  accountsService: AccountsService;
}) {
  const [growthNudgeState, setGrowthNudgeState] = useState<GrowthNudgeState>();

  useEffect(() => {
    void accountsService
      .getGrowthNudges()
      .then((growthNudges) =>
        setGrowthNudgeState(growthNudges[growthNudgeKey]),
      );
  }, [accountsService, growthNudgeKey]);

  const updateGrowthNudge = useCallback(
    (state: GrowthNudgeState) => {
      void accountsService.updateGrowthNudge(growthNudgeKey, { state });
      setGrowthNudgeState(state);
    },
    [accountsService, growthNudgeKey],
  );

  if (growthNudgeState !== 'show') {
    return null;
  }

  return createPortal(
    <div className={styles.layer}>
      <GrowthNudge
        onClick={() => updateGrowthNudge('clicked')}
        onDismiss={() => updateGrowthNudge('dismissed')}
      />
    </div>,
    document.body,
  );
}

// TODO: Make generic for future nudges
export function GrowthNudge({
  onClick,
  onDismiss,
}: {
  onClick: () => void;
  onDismiss: () => void;
}) {
  return (
    <div className={styles.container}>
      <Rows spacing={16}>
        <Inline spacing={16}>
          <Rows spacing={16}>
            <div style={{ width: '32px' }}>
              <IconChat />
            </div>
            <TextMedium>Want to get a live demo?</TextMedium>
            <div style={{ width: '375px' }}>
              <TextSmallLight>
                Contact sales and learn how your team can design and build
                marketing websites faster than ever before with AI.
              </TextSmallLight>
            </div>
          </Rows>
          <Button
            onClick={onDismiss}
            variant="tertiary"
            size="small"
            icon={IconClear}
          />
        </Inline>
        <Rows spacing={16} xalign="start">
          <Button
            onClick={onClick}
            size="medium"
            variant="primary"
            href="/contact-sales"
            label="Contact Sales"
            target="_blank"
          />
        </Rows>
      </Rows>
    </div>
  );
}
